import { uiText, useUiLanguage } from '@/i18n/interface';

import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Trophy } from 'lucide-react';

const NoBeltAssigned: React.FC = () => {
  useUiLanguage();
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Trophy className="h-5 w-5" />
          {uiText("Belt Requirements")}</CardTitle>
        <CardDescription>{uiText("Track your progress toward your next belt level")}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="text-center py-8 text-gray-500">
          <Trophy className="h-12 w-12 mx-auto mb-4 text-gray-300" />
          <p className="text-lg font-medium mb-2">{uiText("No Belt Assigned")}</p>
          <p className="text-sm">
            {uiText("Contact your instructor to have a belt level assigned to your profile.")}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default NoBeltAssigned;
